

































import Vue, { PropType } from "vue";

import { LanguageInfo } from "@/store/types";

import Prism from "vue-prism-component";
import AnchorLink from "../misc/AnchorLink.vue";
import WarningMessage from "../misc/WarningMessage.vue";
import ToggleLanguageButton from "../misc/ToggleLanguageButton.vue";

export default Vue.extend({
  name: "ToggleLanguageCard",
  components: {
    Prism,
    AnchorLink,
    WarningMessage,
    ToggleLanguageButton,
  },
  props: {
    first: {
      type: Object as PropType<LanguageInfo>,
      required: true,
    },
    second: {
      type: Object as PropType<LanguageInfo>,
      required: true,
    },
  },
  data() {
    return {
      selected: this.first,
    };
  },
  methods: {
    setSelected(selected: LanguageInfo) {
      // Avoid redundant state update and navigation
      if (this.selected !== selected) {
        this.selected = selected;

        this.$router.push({ hash: `#${selected.language.anchor}` });
      }
    },
    /**
     * Syncronises the selected state based on current route anchor
     */
    syncSelected() {
      // Remove the # from the start of the hash value
      const anchor = this.$route.hash.substring(1);

      switch (anchor) {
        case this.first.language.anchor:
          this.selected = this.first;
          break;
        case this.second.language.anchor:
          this.selected = this.second;
          break;
      }
    },
  },
  watch: {
    $route() {
      this.syncSelected();
    },
  },
  mounted() {
    this.syncSelected();
  },
});
